import { render, staticRenderFns } from "./RelatorioPrescricao.vue?vue&type=template&id=1e5bc56c&"
import script from "./RelatorioPrescricao.vue?vue&type=script&lang=js&"
export * from "./RelatorioPrescricao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports